const DAYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
const PERIODS = ["am", "pm", "eve"];

const AvailabilityGrid = ({ value = {}, onChange, t }) => {
  const toggle = (day, period) => {
    const cur = value[day] || [];
    const next = cur.includes(period) ? cur.filter((p) => p !== period) : [...cur, period];
    const updated = { ...value, [day]: next };
    if (next.length === 0) delete updated[day];
    onChange(updated);
  };

  return (
    <div className="border border-border overflow-x-auto" data-testid="availability-grid">
      <table className="w-full text-sm">
        <thead className="bg-bone">
          <tr>
            <th className="text-left px-3 py-2.5 text-xs font-heading uppercase tracking-wide text-forest"></th>
            {PERIODS.map((p) => (
              <th key={p} className="px-3 py-2.5 text-xs font-heading uppercase tracking-wide text-forest text-center">
                {t(`periods.${p}`)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {DAYS.map((day) => (
            <tr key={day} className="border-t border-border">
              <td className="px-3 py-2 font-semibold text-forest whitespace-nowrap">{t(`days.${day}`)}</td>
              {PERIODS.map((p) => (
                <td key={p} className="px-3 py-2 text-center">
                  <input
                    type="checkbox"
                    data-testid={`avail-${day}-${p}`}
                    checked={(value[day] || []).includes(p)}
                    onChange={() => toggle(day, p)}
                    className="h-5 w-5 accent-burnt cursor-pointer"
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AvailabilityGrid;
